export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4712.5d93bd32.jpg";